import { getFirstInterest, getLsi, getPaymentInstallment } from '@hex/shared/utils';
import { useCallback, useMemo } from 'react';
import { LoanCalculatorForm } from '../types';

export const useCostCalculator = (data?: LoanCalculatorForm) => {
  const calculations = useCallback(() => {
    if (!data) {
      return {
        monthlyInstallment: 0,
        firstInterest: 0,
        insurancePremiumValue: 0,
        firstPayment: 0,
        amortization: 0,
      };
    }

    const {
      loanRepaymentSecurity,
      loanAmount,
      interest,
      firstAge,
      secondAge,
      insuredPeople,
      lsiLevel,
      repaymentMethod,
      maturity,
    } = data;
    const insurancePremiumValue = loanRepaymentSecurity
      ? Math.round(
          getLsi({
            loanAmount,
            firstAge: firstAge ? parseInt(firstAge) : null,
            secondAge: secondAge ? parseInt(secondAge) : null,
            insuredPeople: insuredPeople ? parseInt(insuredPeople) : 0,
            loanSecurity: lsiLevel,
          }),
        )
      : 0;
    const firstInterest = Math.round(getFirstInterest(loanAmount, parseFloat(interest)));
    const firstPayment = Math.round(getPaymentInstallment(loanAmount, parseFloat(interest), repaymentMethod, maturity));
    const amortization = firstPayment - firstInterest;

    return {
      monthlyInstallment: firstPayment + insurancePremiumValue,
      firstInterest,
      insurancePremiumValue,
      firstPayment,
      amortization,
    };
  }, [data]);

  return useMemo(() => calculations(), [calculations]);
};
